import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    unitList: () => {
        return HTTP.get('/stock/setting/unit-all', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addUnit: (data) => {
        return HTTP.post('/stock/setting/unit-create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editUnit: (id,data) => {
        return HTTP.post(`/stock/setting/unit-update/${id}`,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailUnit: (id) => {
        return HTTP.get(`stock/setting/unit-edit/${id}`, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}